<div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
    <mat-form-field class="w-80" [formGroup]="ficheAjoutNiveau">

        <mat-label>Niveau</mat-label>
        <input type="text"
               matInput
               formControlName="champ_niveau"
               [matAutocomplete]="materialInput">
        <mat-autocomplete #materialInput="matAutocomplete">
            <mat-option *ngFor="let option of niveauxRestant" [value]="option.niveau">{{option.niveau}}</mat-option>
        </mat-autocomplete>

    </mat-form-field>
    <button type="button" class="ml-4" MatSuffix mat-flat-button [color]="'primary'" style="top:25px;" (click)="ajouterEtage()">
        Ajouter
    </button>
</div>
<div class="flex flex-row sm:flex-row pb-0 space-x-4">
    <div class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent border">
        <!-- <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between pb-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Pièces</div>
        </div> -->

        <div class="flex flex-auto overflow-hidden" *ngIf="isLoaded">
            <div class="flex flex-col flex-auto overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid-pieces z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Plan</div>
                        <div class="right-0 text-right">Croquis</div>
                    </div>
                    <ng-container *ngFor="let etage of etages;">
                        <div class="table-grid-pieces grid items-center gap-4 py-3 px-6 md:px-8">
                            <div class="">{{etage.nom_niveau}}</div>
                            <div class="right-0 text-right">
                                <a [routerLink]="['/dossiers-interventions', idDossierIntervention, 'croquis', etage.id]" class="min-w-10 min-h-7 h-7 px-2 mx-1 leading-6" mat-stroked-button>
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                </a>
                                <button class="min-w-10 min-h-7 h-7 px-2  mx-1 leading-6" mat-stroked-button (click)="afficher_image(etage.id)" [disabled]="!etage.croquis_id">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                </button>
                                <button class="min-w-10 min-h-7 h-7 px-2  ml-1 leading-6" mat-stroked-button (click)="delete(etage.id)" *ngIf="isAdmin">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>


<div id="croquis_image_svg" style="width: fit-content; padding: 10px; position: absolute; top:-2000px;">
    <img src="assets/images/logo/logo_urgex.jpg" style="margin:auto; margin-bottom: 30px; max-width: 200px;">
    <div id="croquis_image_svg_content" style="width: fit-content;">
    </div>
</div>
<div id="croquis_image_png" style="width: fit-content; position: absolute; top:-2000px;">
</div>
